const input = {
    username: 'Username',
    password: 'Password',
    email: 'Email',
    phone_number: 'Phone number',
    confirm_password: 'Confirm password',
    search_region_code: 'Search country code',
    backup_code: 'Backup code',
    code: 'Code',
    label_with_optional: '{{label}} (Optional)',
};
export default Object.freeze(input);
